/** Fixed daily cron: minute hour * * * (no lists, ranges, or steps). */
const DAILY_FIXED_CRON = /^(\d+) (\d+) \* \* \*$/;

export const IZIVIA_MONPROJET_MIN_CRON_SEPARATION_HOURS = 2;

export function dailyFixedCronToMinutesOfDay(
  expression: string,
): number | null {
  const match = expression.trim().match(DAILY_FIXED_CRON);
  if (!match) {
    return null;
  }
  const minute = Number(match[1]);
  const hour = Number(match[2]);
  if (
    !Number.isInteger(minute) ||
    !Number.isInteger(hour) ||
    minute < 0 ||
    minute > 59 ||
    hour < 0 ||
    hour > 23
  ) {
    return null;
  }
  return hour * 60 + minute;
}

/** Shortest distance between two times on a 24h clock, in minutes. */
export function circularMinuteGap(a: number, b: number): number {
  const diff = Math.abs(a - b);
  return Math.min(diff, 24 * 60 - diff);
}

export function iziviaMonprojetCronSchedulesMeetMinimumSeparation(
  casesSchedule: string,
  workOrdersSchedule: string,
  minHours: number = IZIVIA_MONPROJET_MIN_CRON_SEPARATION_HOURS,
): boolean {
  const casesMinutes = dailyFixedCronToMinutesOfDay(casesSchedule);
  const workOrdersMinutes = dailyFixedCronToMinutesOfDay(workOrdersSchedule);
  if (casesMinutes === null || workOrdersMinutes === null) {
    return false;
  }
  const minMinutes = minHours * 60;
  return circularMinuteGap(casesMinutes, workOrdersMinutes) >= minMinutes;
}

export function validateIziviaMonprojetCronScheduleSeparation(
  casesSchedule: string,
  workOrdersSchedule: string,
  minHours: number = IZIVIA_MONPROJET_MIN_CRON_SEPARATION_HOURS,
): void {
  const casesMinutes = dailyFixedCronToMinutesOfDay(casesSchedule);
  const workOrdersMinutes = dailyFixedCronToMinutesOfDay(workOrdersSchedule);
  if (casesMinutes === null || workOrdersMinutes === null) {
    throw new Error(
      'Izivia monprojet cron schedules must use fixed daily expressions (minute hour * * *)',
    );
  }
  const gap = circularMinuteGap(casesMinutes, workOrdersMinutes);
  const minMinutes = minHours * 60;
  if (gap < minMinutes) {
    throw new Error(
      `Izivia incidents and interventions cron triggers must be at least ${minHours} hours apart`,
    );
  }
}
